__turbopack_context__.v({
  "className": "XMO7cG_className",
});
